<script lang="ts" setup>
defineProps<{
  game: TrainingGameInfo
}>()
</script>

<template>
  <UiListItem class="text-left">
    <UiAvatar>
      <NuxtImg
        :src="game.image"
        class="w-16 aspect-square"
        :alt="game.name"
      />
    </UiAvatar>
    <UiListContent>
      <UiListTitle :title="game.name" />
      <UiListSubtitle :subtitle="game.purpose" />
    </UiListContent>
    <slot name="icon">
      <Icon
        name="tabler-chevron-right"
        class="size-10"
      />
    </slot>
  </UiListItem>
</template>
